import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from "@angular/forms";
import { FlashMessagesService } from "angular2-flash-messages";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { Router } from '@angular/router';
import { CommonProjectDataService } from "../../_services/common-project-data.service";

export interface DialogData {
  saveFrom: string;
  company_id: string;
}

@Component({
  selector: 'app-create-client',
  templateUrl: './create-client.component.html',
  styleUrls: ['./create-client.component.css']
}) 
export class CreateClientComponent implements OnInit {
  addClientForm: FormGroup;
  loading: false;
  public result = "";
  public profileIconText = "";
  public selectedFile = null;
  public validate_address=false;
  public userDetails:any={};
  public countryList:Array<any>=[]; 
  public isPublicQuoteCreation = false;
  public companyId = null;
  constructor(private fb: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    public dialogRef: MatDialogRef<CreateClientComponent>,
    private CommonService: CommonService,
    private router: Router,
    private CommonProjectDataService: CommonProjectDataService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.companyId = (this.data && this.data.company_id) ? this.data.company_id : null;
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    this.addClientForm = this.fb.group({
      email: [null, [Validators.email, Validators.required]],
      phone: [null],
      company: [null],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      profile_img: [null],
      shippingAddress1: [null],
      shippingAddress2: [null],
      shippingCity: [null],
      shippingState: [null],
      shippingZip: [null],
      country: [null]
    })
    if(this.companyId){
      this.addClientForm.addControl('department', new FormControl(null, Validators.required));
    }
  }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));  
    this.countryList=this.CommonProjectDataService.getCountryList(); 
  }

  saveClientFormData = function (postData) {
    if (this.addClientForm.valid) {
      this.loading = true;
      // Update the postData object in place with the sanitized values.
      Object.keys(postData).forEach(key => {
        const value = postData[key];
        postData[key] = value === '' ? null : value;
      });
      
      const formData = new FormData();
      formData.append('register_type', 'RegisterViaShopAdmin');
      formData.append('id', localStorage.getItem("userID"));
      formData.append('first_name', postData.firstName);
      formData.append('last_name', postData.lastName);
      formData.append('email', postData.email);
      formData.append('shipping_address1', postData.shippingAddress1);
      formData.append('shipping_address2', postData.shippingAddress2);
      formData.append('shipping_city', postData.shippingCity);
      formData.append('shipping_state', postData.shippingState);
      formData.append('shipping_zip', postData.shippingZip);
      formData.append('country', this.countryList[0].countryCode);
      formData.append('phone', postData.phone);
      formData.append('validate_address',this.validate_address);
      if(this.selectedFile){
        formData.append('profile_img', this.selectedFile, this.selectedFile.name);
      }
      if(this.companyId){
        formData.append('company_id', this.companyId);
        formData.append('department', postData.department);
      }
      if(postData.company)
      formData.append('company_name',postData.company);
      
      this.CommonService.apiService(
        "POST",
        "user/create",
        formData
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            this.result = "success";
            if (this.data == null) {
              this.onNoClick();
              this.router.navigate(['/clients/listing', { id: response.data.user_id }]);              
            }
            else if(this.companyId != null){
              this.router.navigate(['/clients/listing', { id: this.companyId }]);
              this.onNoClick();
            }
            else {
              this.result = postData.firstName + ' ' + postData.lastName;
              this.onNoClick();
            }

          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      );
    } else {
      this.validateAllFormFields(this.addClientForm);
    }
  };

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  isFieldValid(field: string) {
    return (
      !this.addClientForm.get(field).valid &&
      this.addClientForm.get(field).touched
    );
  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }

  onProfileChanged = function (event) {
    this.selectedFile = event.target.files[0];
    this.profileIconText = this.selectedFile.name;
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-master/create-client/create-client.component.ts